import { useState } from 'react'
import { faCog } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from 'design-system/button'
import { ButtonVariant, ButtonSizes, ButtonColors } from 'design-system/button/src/Button'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'
import OptionsForm from './OptionsForm'
import styles from './Options.module.scss'

interface Props {
  disabled?: boolean
}

export const Options = ({ disabled }: Props) => {
  const [open, setOpen] = useState(false)
  const t = useTranslationRankmi({ prefix })
  return (
    <>
      <Button
        color={ButtonColors.BlueLighten}
        className={styles.button}
        size={ButtonSizes.Small}
        block
        onClick={() => {
          setOpen(true)
        }}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faCog} className="mr-1" />
        {t('options')}
      </Button>
      <OptionsForm
        show={open}
        onHide={() => {
          setOpen(false)
        }}
        onSave={() => {
          setOpen(false)
        }}
      />
    </>
  )
}

export default Options
